import { Link } from 'react-router-dom';

function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-blue-600 text-white shadow-lg">
        <div className="container mx-auto px-4 py-6">
          <Link to="/" className="text-4xl font-bold hover:text-blue-100 transition">📰 NotíciasWeb</Link>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold text-gray-800 mb-8">Termos de Uso</h1>
        
        <div className="bg-white rounded-lg shadow-md p-8 prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">Data de última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">1. Aceitação dos Termos</h2>
          <p className="text-gray-700 mb-6">
            Ao acessar e usar o NotíciasWeb, você concorda em cumprir estes termos de uso. 
            Se não concordar com algum termo, por favor, não utilize nosso site.
          </p>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">2. Uso do Conteúdo</h2>
          <p className="text-gray-700 mb-4">
            Todo o conteúdo publicado no NotíciasWeb, incluindo textos, imagens e gráficos, 
            é protegido por direitos autorais.
          </p>
          <ul className="list-disc pl-6 text-gray-700 mb-6">
            <li>Você pode compartilhar links para nossas notícias</li>
            <li>É proibida a reprodução total ou parcial sem autorização</li>
            <li>O uso comercial do conteúdo requer permissão prévia</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">3. Responsabilidades do Usuário</h2>
          <p className="text-gray-700 mb-4">
            Ao utilizar nosso site, você concorda em:
          </p>
          <ul className="list-disc pl-6 text-gray-700 mb-6">
            <li>Não violar leis ou regulamentos aplicáveis</li>
            <li>Não transmitir conteúdo prejudicial ou ofensivo</li>
            <li>Não tentar acessar áreas restritas do site</li>
            <li>Não interferir no funcionamento do site</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">4. Informações e Opiniões</h2>
          <p className="text-gray-700 mb-6">
            O conteúdo publicado no NotíciasWeb é fornecido "como está" e para fins informativos. 
            Não garantimos a precisão, completude ou atualidade das informações.
          </p>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">5. Links Externos</h2>
          <p className="text-gray-700 mb-6">
            Nosso site pode conter links para sites de terceiros. Não somos responsáveis pelo 
            conteúdo ou práticas de privacidade desses sites.
          </p>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">6. Limitação de Responsabilidade</h2>
          <p className="text-gray-700 mb-6">
            O NotíciasWeb não será responsável por quaisquer danos diretos, indiretos, incidentais 
            ou consequenciais resultantes do uso ou incapacidade de usar nosso site.
          </p>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">7. Modificações</h2>
          <p className="text-gray-700 mb-6">
            Reservamo-nos o direito de modificar estes termos a qualquer momento. As alterações 
            entrarão em vigor imediatamente após sua publicação no site.
          </p>

          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">8. Contato</h2>
          <p className="text-gray-700 mb-4">
            Para dúvidas sobre estes termos, entre em contato conosco através do{' '}
            <Link to="/contato" className="text-blue-600 hover:underline">formulário de contato</Link>.
          </p>
        </div>

        <div className="mt-8 text-center">
          <Link to="/" className="text-blue-600 hover:underline">← Voltar para home</Link>
        </div>
      </main>
    </div>
  );
}

export default TermsOfService;